// if (!customElements.get('product-add-to-cart-sticky')) {
//     class ProductAddToCartSticky extends HTMLElement {
//       constructor() {
//         super();
//         this.handleScroll = this.handleScroll.bind(this);
//         this.sectionId = this.dataset.section;
//         this.variantChangeUnsubscriber = undefined;
//       }
  
//       connectedCallback() {
//         this.targetElement = document.querySelector('[id^="ProductSubmitButton-"]');
//         this.footerElement = document.querySelector('footer');
//         this.stickyAtcVariantInput = this.querySelector('.product-variant-id');
  
//         window.addEventListener("scroll", this.handleScroll);
        
//         this.variantChangeUnsubscriber = subscribe(
//           PUB_SUB_EVENTS.variantChange,
//           this.handleVariantChange.bind(this)
//         );
  
//         this.handleScroll();
//       }
  
//       disconnectedCallback() {
//         window.removeEventListener("scroll", this.handleScroll);
        
//         if (this.variantChangeUnsubscriber) {
//           this.variantChangeUnsubscriber();
//         }
//       }
  
//       getAbsoluteTop(element) {
//         if (!element) return 0;
//         let top = 0;
//         while (element) {
//           top += element.offsetTop || 0;
//           element = element.offsetParent;
//         }
//         return top;
//       }
  
//       handleScroll() {
//         if (!this.targetElement || !this.footerElement) return;
  
//         const targetTopPosition = this.getAbsoluteTop(this.targetElement);
//         const footerTopPosition = this.getAbsoluteTop(this.footerElement);
//         const isTargetElementOutOfView = targetTopPosition < window.scrollY;
//         const isFooterInView = window.scrollY + window.innerHeight > footerTopPosition;
  
//         if (isTargetElementOutOfView && !isFooterInView) {
//           this.classList.add('show');
//         } else {
//           this.classList.remove('show');
//         }
//       }
  
//       handleVariantChange({ data: { sectionId, html, variant } }) {
//         const mainSectionId = this.sectionId.replace(/^template--\d+__/, '');
//         const eventSectionId = sectionId.replace(/^template--\d+__/, '');
        
//         if (mainSectionId !== eventSectionId) return;
  
//         // Update variant input
//         if (this.stickyAtcVariantInput) {
//           this.stickyAtcVariantInput.value = variant?.id || '';
//           this.stickyAtcVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
//         }
  
//         this.updateStickyOptionsFromHTML(sectionId, html);
//       }
  
//       updateStickyOptionsFromHTML(sectionId, html) {
//         const sourceOptionsContainer = html.querySelector('.selected-variant-details .options-container');
//         const destinationOptionsContainer = this.querySelector('.selected-variant-details .options-container');
  
//         if (!sourceOptionsContainer || !destinationOptionsContainer) return;
  
//         const sourceOptions = sourceOptionsContainer.querySelectorAll('.selected-variant-option');
//         const destinationOptions = destinationOptionsContainer.querySelectorAll('.selected-variant-option');
  
//         sourceOptions.forEach((sourceOption, index) => {
//           if (destinationOptions[index]) {
//             destinationOptions[index].textContent = sourceOption.textContent;
//           }
//         });
//       }
//     }
  
//     customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
//   }


if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.handleViewportChange = this.handleViewportChange.bind(this);
      this.checkInitialVisibility = this.checkInitialVisibility.bind(this);

      this.sectionId = this.dataset.section;
      this.observer = null;
      this.targetElement = null;
      this.stickyAtcVariantInput = null;
    }

    connectedCallback() {
      this.targetElement = document.querySelector(
        `#MainProduct-${this.sectionId} .product-form__submit`
      );

      this.stickyAtcVariantInput = this.querySelector('.product-variant-id');

      if (!this.targetElement) return;

      // Observe normal Add to Cart button
      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];

          this.handleViewportChange(entry.isIntersecting);
        },
        {
          root: null,
          threshold: 0
        }
      );

      this.observer.observe(this.targetElement);

      // Keep variant information in sticky ATC updated
      document.body.addEventListener(
        'change',
        this.handleVariantChange
      );

      // Check state immediately on page load
      this.checkInitialVisibility();

      // Re-check on resize
      window.addEventListener(
        'resize',
        this.checkInitialVisibility
      );
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }

      document.body.removeEventListener(
        'change',
        this.handleVariantChange
      );

      window.removeEventListener(
        'resize',
        this.checkInitialVisibility
      );
    }

    handleViewportChange(isNormalAtcVisible) {
      if (isNormalAtcVisible) {
        this.classList.remove('show');
      } else {
        this.classList.add('show');
      }
    }

    checkInitialVisibility() {
      if (!this.targetElement) return;

      const rect = this.targetElement.getBoundingClientRect();

      const isVisible =
        rect.top < window.innerHeight &&
        rect.bottom > 0;

      this.handleViewportChange(isVisible);
    }

    updateStickyATCOption(optionName, optionValue) {
      const matches = optionName.match(/options\[(.+)\]/);

      if (matches && matches[1]) {
        optionName = matches[1];
      }

      const optionDisplay = this.querySelector(
        '.selected-variant-option[data-option-name="' +
          optionName +
          '"]'
      );

      if (optionDisplay) {
        optionDisplay.textContent =
          optionName + ': ' + optionValue;
      }
    }

    handleVariantChange(event) {
      const target = event.target;

      const productSection = target.closest(
        `#MainProduct-${this.sectionId}`
      );

      if (!productSection) return;

      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'SELECT'
      ) {
        const optionName = target.name;

        const optionValue =
          target.tagName === 'INPUT'
            ? target.value
            : target.options[target.selectedIndex].textContent;

        this.updateStickyATCOption(
          optionName,
          optionValue
        );
      }
    }
  }

  customElements.define(
    'product-add-to-cart-sticky',
    ProductAddToCartSticky
  );

//  updateStickyOptionsFromHTML(sectionId, html) {
//         const sourceOptionsContainer = html.querySelector('.selected-variant-details .options-container');
//         const destinationOptionsContainer = this.querySelector('.selected-variant-details .options-container');
  
//         if (!sourceOptionsContainer || !destinationOptionsContainer) return;
  
//         const sourceOptions = sourceOptionsContainer.querySelectorAll('.selected-variant-option');
//         const destinationOptions = destinationOptionsContainer.querySelectorAll('.selected-variant-option');
  
//         sourceOptions.forEach((sourceOption, index) => {
//           if (destinationOptions[index]) {
//             destinationOptions[index].textContent = sourceOption.textContent;
//           }
//         });
//       }
}
  